import { cn } from 'cn';
import * as React from 'react';

interface InputProps extends Omit<React.ComponentProps<'input'>, 'size'> {
  size?: 'default' | 'small';
}

function Input({ className, type, size = 'default', ...props }: InputProps) {
  // The base text size preserves the Theme/index.ts:686-695 16px input size and
  // prevents iOS Safari from zooming the viewport on focus.
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'h-9 w-full min-w-0 rounded-md border border-input bg-background px-3 py-1 transition-colors outline-none placeholder:text-muted-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
        // 13px: Theme/index.ts:691-693 input sizeSmall fontSize, no Tailwind scale match.
        size === 'small' ? 'text-[13px]' : 'text-base',
        'focus-visible:focus-ring',
        'aria-invalid:border-destructive',
        className,
      )}
      {...props}
    />
  );
}

export { Input };
